/* global Playbuzz */
import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import FileLoader from 'scripts/helpers/FileLoader'
import Constants from 'scripts/base/Constants'
import ClientErrors from 'scripts/lib/ClientErrors'
import PollRenderer from 'scripts/components/embed/Poll'
import {lazyLoader, DOMElem} from 'scripts/lib/utils'
import { connect } from 'scripts/store'

export class BodyRender extends Component {
  isLinkDone = false
  isScriptDone = false
  isIframeDone = false
  isImgsDone = false
  state = { auth: false }
  domRefs = (node) => {
    this.domrefs = node
  }

  linkTarget = () => {
    if (this.isLinkDone) { return null }

    let links = DOMElem(this.domrefs, 'a')
    if (links.length !== 0) {
      this.isLinkDone = true
      for (var i = 0; i < links.length; i++) {
        links[i].setAttribute('target', '_blank')
      }
    }
  }

  // Checks if the content or src of the script is allowed to execute
  isTrusted = (data) => {
    const allowedurl = Object.values(Constants.AllowedEmbeds)
    var trust = false
    for (var i = 0; i < allowedurl.length; i++) {
      if (data.indexOf(allowedurl[i]) !== -1) {
        trust = true
        break
      }
    }
    return trust
  }

  // Check if the embed requires a re-render
  doEmbedRenders = (string) => {
    const embeds = Constants.AllowedEmbeds
    const allowedurl = Object.values(Constants.AllowedEmbeds)
    var match = ''
    for (var i = 0; i < allowedurl.length; i++) {
      if (string.indexOf(allowedurl[i]) !== -1) {
        match = allowedurl[i]
        break
      }
    }
    switch (match) {
      case embeds.PLAYBUZZ:
        if (typeof Playbuzz !== 'undefined') {
          Playbuzz.render()
        }
        break
    }
  }

  doEvalScript = (string) => {
    if (this.isTrusted(string)) {
      try {
        /* eslint no-eval: 0 */
        eval(string)
        this.doEmbedRenders(string)
      } catch (e) {
        // do nothing
        ClientErrors({
          message: 'A script eval has failed.',
          error: e
        })
      }
      return true
    }
    return false
  }

  doScriptReload = (ref) => {
    const src = ref.src
    if (this.isTrusted(src)) {
      ref.parentNode.removeChild(ref)
      // re-insert the script
      const file = new FileLoader()
      file.load(src, src)
    }
  }

  execScripts = () => {
    if (this.isScriptDone) { return null }
    Array.from(DOMElem(this.domrefs, 'script')).forEach((item) => {
      if (item.src) {
        this.doScriptReload(item)
      } else {
        this.doEvalScript(item.innerHTML)
      }
    })
    this.isScriptDone = true
  }

  wrapIframe = () => {
    if (this.isIframeDone) { return null }
    Array.from(DOMElem(this.domrefs, 'iframe')).forEach((item) => {
      var parentNode = item.parentNode
      if (!parentNode.classList.contains('embed-youtube') &&
          !parentNode.classList.contains('fluid-width-video-wrapper') &&
          !item.classList.contains('interact-app-container') &&
          !item.classList.contains('soompi-embeds') &&
          !item.classList.contains('instagram-media')) {
        var span = document.createElement('span')
        span.setAttribute('class', 'embed-youtube')
        span.setAttribute('style', 'text-align:center; display: block;')
        span.appendChild(item.cloneNode())
        parentNode.appendChild(span)
        parentNode.removeChild(item)
      } else if (item.classList.contains('soompi-embeds')) {
        item.onload = (obj) => {
          const { target } = obj
          setTimeout(() => {
            target.style.height = (target.contentWindow.document.body.scrollHeight + 50) + 'px'
          }, 1000)
        }
      }
    })
    this.isIframeDone = true
  }

  lazyLoadImages = () => {
    if (this.isImgsDone) { return null }
    lazyLoader(this.domrefs)
    this.isImgsDone = true
  }

  renderPollsNoAuth = () => {
    if (this.isPollsDone) { return null }
    Array.from(DOMElem(this.domrefs, 'p')).forEach((item) => {
      var children = item.childNodes
      Array.from(children).forEach((child) => {
        if (child.nodeName === 'A') {
          if (child.classList.contains('soompi-polls')) {
            const pollId = child.dataset.poll
            const layout = child.dataset.type || 'default'
            var parentNode = item.parentNode
            var temp = document.createElement('div')
            temp.dataset.poll = pollId
            temp.dataset.type = layout
            temp.classList.add('soompi-polls-rendered')
            ReactDOM.render(<PollRenderer auth={this.state.auth} layout={layout} id={pollId} />, temp)
            parentNode.replaceChild(temp, item)
          }
        }
      })
    })
    this.isPollsDone = true
  }

  renderPollsAuth = () => {
    Array.from(DOMElem(this.domrefs, 'div')).forEach((item) => {
      if (item.classList.contains('soompi-polls-rendered')) {
        const pollId = item.dataset.poll
        const layout = item.dataset.type || 'default'
        var parentNode = item.parentNode
        var temp = document.createElement('div')
        temp.dataset.poll = pollId
        temp.dataset.type = layout
        temp.classList.add('soompi-polls-rendered')
        ReactDOM.render(<PollRenderer auth={this.state.auth} layout={layout} id={pollId} />, temp)
        parentNode.replaceChild(temp, item)
      }
    })
  }

  componentDidUpdate () {
    this.linkTarget()
    this.renderPollsNoAuth()
    this.wrapIframe()
    this.execScripts()
    this.lazyLoadImages()
  }

  componentWillReceiveProps() {
    this.isLinkDone = false
    this.isPollsDone = false
    this.isScriptDone = false
    this.isIframeDone = false
    this.isImgsDone = false
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps !== this.props && nextProps.auth) {
      this.setState({auth: nextProps.auth}, () => {
        this.renderPollsAuth()
      })
    }
    return true
  }

  render() {
    return <div dangerouslySetInnerHTML={{__html: this.props.html}} ref={this.domRefs} />
  }
}

const mapToProps = ({auth}) => {
  return {auth}
}
export default connect(mapToProps)(BodyRender)



// WEBPACK FOOTER //
// ./assets/js/components/article/BodyRender.jsx